import React from 'react';
import {PageService, PageSolution} from '../models';

export interface PageContextProps {
    service?: PageService;
    solution?: PageSolution;
}

export default React.createContext<PageContextProps>({});
